var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780-780v200h-40v-130.69L534.85-507.31q19.77 28.77 32.46 60.77Q580-414.54 580-380q0 83.64-58.16 141.82Q463.68-180 380.07-180q-83.61 0-141.84-58.16Q180-296.32 180-379.93q0-83.61 58.18-141.84Q296.36-580 380-580q34.54 0 66.15 12.58 31.62 12.57 60.16 32.57L711.46-740H580v-40h200ZM379.88-540q-66.34 0-113.11 46.89Q220-446.21 220-379.88q0 66.34 46.89 113.11Q313.79-220 380.12-220q66.34 0 113.11-46.89Q540-313.79 540-380.12q0-66.34-46.89-113.11Q446.21-540 379.88-540Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.30917c44ff88ee23e21419a5480ee32a.svg";
export { ForwardRef as ReactComponent };